import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';
import { Container } from '@comparethemarketau/manor-grid';

import { Button } from '@comparethemarketau/manor-button';
import { connect } from 'react-redux';

import { AlexanderHalfPicture } from './alexander_half_picture';
import { updateResultsStateMapping, updateResultsDispatchMapping } from './filter_store_mapping';

const useStyles = createUseStyles((theme) => ({
    backgroundBox: {
        backgroundColor: theme.colors.primary50,
        width: '100%'
    },
    container: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-start',
        paddingTop: theme.spacing[12],
        paddingBottom: theme.spacing[12]
    },
    updateButton: {
        marginBottom: 0,
        width: theme.spacing[136],
        height: theme.spacing[48]
    },
    undoButton: {
        marginBottom: 0,
        width: 'fit-content',
        marginLeft: theme.spacing[32]
    }
}));

// prvious implement on search by hasUnappliedFilterChanges
const _UpdateResultsSection = (props) => {
    const { isShowFiltersUpdateButton, applyUpdateResults, undoStaged, className } = props;
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });

    if (!isShowFiltersUpdateButton) {
        return null;
    }

    const handleUpdate = () => {
        applyUpdateResults(true);
    };

    const handleUndo = () => {
        undoStaged();
    };

    return (
        <div className={classNames('test-productsPolicyFilters-updateResults', classes.backgroundBox)}>
            <Container padding={['0', '32', '0', '32']}>
                <div className={classNames(classes.container, className)}>
                    <div>
                        <Button
                            id="filters-update-results-button"
                            trackingLabel="Update Results Button"
                            variant="secondary"
                            handleClick={handleUpdate}
                            className={classes.updateButton}
                        >
                            Update results
                        </Button>
                    </div>
                    <div>
                        <Button
                            id="filters-undo-button"
                            trackingLabel="Undo Filter Button"
                            variant="tertiary"
                            handleClick={handleUndo}
                            className={classes.undoButton}
                        >
                            Undo
                        </Button>
                    </div>
                </div>
                <AlexanderHalfPicture full />
            </Container>
        </div>
    );
};

_UpdateResultsSection.propTypes = {
    className: PropTypes.string,
    isShowFiltersUpdateButton: PropTypes.bool,
    applyUpdateResults: PropTypes.func,
    undoStaged: PropTypes.func
};

const UpdateResultsSection = connect(updateResultsStateMapping, updateResultsDispatchMapping)(_UpdateResultsSection);
export { UpdateResultsSection };
